var render, staticRenderFns
import script from "./TText.vue?vue&type=script&lang=js&"
export * from "./TText.vue?vue&type=script&lang=js&"
import style0 from "./TText.vue?vue&type=style&index=0&id=b49f1f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49f1f5a",
  null
  
)

export default component.exports